<div class="container">

    <mat-card class="mt-3">
        <mat-card-content>
                        <app-surcharge-pricing-form></app-surcharge-pricing-form>
        </mat-card-content>
    </mat-card>

</div>